import React from 'react';
import { SourceType } from '@/modules/surgicalEvent';
import MemoryIcon from '@mui/icons-material/Memory';
import { SourceTypeTooltip } from './SourceTypeTooltip';

export const OcrBadge = () => (
  <div className="source-type-icon ocr">
    <SourceTypeTooltip sourceType={SourceType.OCR}>
      <MemoryIcon />
    </SourceTypeTooltip>
  </div>
);
